import { withScalars } from 'apollo-link-scalars';
import dayjs from 'dayjs';
import { buildClientSchema } from 'graphql';

import schemaJson from '@/lib/apollo/links/customScalar/gen/graphql.schema.json';
import { dayjst } from '@/lib/dayjst';

export const customScalarLink = withScalars({
  schema: buildClientSchema(schemaJson as any),
  typesMap: {
    Date: {
      serialize: (parsed: unknown) => {
        if (dayjs.isDayjs(parsed)) {
          return parsed.format('YYYY-MM-DD');
        }
        return typeof parsed === 'string' ? parsed : '';
      },
      parseValue: (raw: unknown) => {
        return typeof raw === 'string' && raw ? dayjst(raw) : null;
      },
    },
    Time: {
      serialize: (parsed: unknown) => {
        if (dayjs.isDayjs(parsed)) {
          return parsed.format();
        }
        return typeof parsed === 'string' ? parsed : '';
      },
      parseValue: (raw: unknown) => {
        return typeof raw === 'string' && raw ? dayjst(raw) : null;
      },
    },
  },
});
